<script>
	export default {
		name: 'SendGridExecuter',
		methods: {
			sendGridPost(to, from, cc, bcc, subject, html) {
				const self_ = this;

				const body_ = {
					to: to,
					from: from,
					cc: cc,
					bcc: bcc,
					subject: subject,
					html: html
				}
				
				return self_.callFunction('emailFunction', 'post' , { body: body_ })
			}
		}
	}
</script>